import {debounce} from "throttle-debounce";
import {fetchJson} from "../../assets/request";
import loader from "../../assets/loader";
import navigationHelper from "../../assets/navigation-helper";
import FormBaseController from "../form_base_controller";

const AUTOSAVE_DELAY = 2000;        // Millisekunden nach letzter Änderung

export default class extends FormBaseController {
  static targets = [
    "manufacturer_id",
    "manufacturer_name",
    "manufacturer_name_row",
    "submitButton",
    "offerer_status",
    "mch_identification",
    "machine_type_id",
    "mch_advert_type",
    "messages",
    "offer_safety"
  ];

  connect() {
    super.connect();
    if (this.hasManufacturer_idTarget) {
      this.onManufacturerIdChange();
    }

    // Autosave nur wenn aktiviert
    if (this.element.dataset.autosave) {
      this.onchange = debounce(AUTOSAVE_DELAY, e => this.saveDraft().catch(() => {
      }));
      this.form.addEventListener("change", this.onchange);
    }

    this.onOffererStatusChange = this.onOffererStatusChange.bind(this);
    this.offerer_statusTarget.addEventListener("change", this.onOffererStatusChange);
    this.onOffererStatusChange();
    // Maschinenbezeichnung nur für gewerbliche Angebote anzeigen
    if (this.hasOfferer_statusTarget && this.hasMch_identificationTarget) {
      this.mch_identification_display = this.mch_identificationTarget.style.display;
      this.mch_identification = this.mch_identificationTarget.querySelector("input").value;
    }

    this.saveAndReloadForm = this.saveAndReloadForm.bind(this);
    if (this.hasMch_advert_typeTarget) {
      this.mch_advert_typeTarget.addEventListener("change", this.saveAndReloadForm, {
        once: true
      });
    }
    if (this.hasMachine_type_idTarget) {
      this.machine_type_idTarget.addEventListener("change", this.saveAndReloadForm, {
        once: true
      });
    }
  }

  disconnect() {
    console.log(this.offerer_statusTarget.value);
    super.disconnect();
    this.form.removeEventListener('change', this.onchange);
    if (this.hasOfferer_statusTarget) {
      this.offerer_statusTarget.removeEventListener("change", this.onOffererStatusChange);
    }
    if (this.hasMch_advert_typeTarget) {
      this.mch_advert_typeTarget.removeEventListener("change", this.saveAndReloadForm);
    }
    if (this.hasMachine_type_idTarget) {
      this.machine_type_idTarget.removeEventListener("change", this.saveAndReloadForm);
    }
  }

  onManufacturerIdChange() {
    if (this.manufacturer_id !== 0) {
      this.manufacturer_name_rowTarget.classList.add("hidden");
      this.manufacturer_nameTarget.disabled = true;
    } else {
      this.manufacturer_name_rowTarget.classList.remove("hidden");
      this.manufacturer_nameTarget.disabled = false;
    }
  }

  onSaveDraftButtonClick(event) {
    event.preventDefault();
    loader.show();
    this.saveDraft()
      .then(() => {
        let url = event.target.dataset.successUrl;
        if (url) {
          navigationHelper.goto(url);
        } else {
          loader.hide();
        }
      })
      .catch((response) => {
        if (response.messages) {
          if (this.hasMessagesTarget && response.messages_html) {
            this.messagesTarget.innerHTML = response.messages_html;
            this.messagesTarget.scrollIntoView({behavior: 'smooth'});
          } else {
            alert(window.translate("tpWeb.frontend.global.addMachineConfirm.label.pleaseVerifyYourOffer"));
          }
        }
        loader.hide();
      });
  }

  onOffererStatusChange() {
    if (this.offerer_statusTarget.value === "commercial") {
      if (this.hasMch_identificationTarget) {
        this.mch_identificationTarget.style.display = this.mch_identification_display;
        this.mch_identificationTarget.querySelector("input").value = this.mch_identification || "";
      }
      this.offer_safetyTarget.closest('div').style.display = "block";
    } else {
      this.offer_safetyTarget.closest('div').style.display = "none";
      if (this.hasMch_identificationTarget) {
        this.mch_identificationTarget.style.display = "none";
        this.mch_identification = this.mch_identificationTarget.querySelector("input").value
        this.mch_identificationTarget.querySelector("input").value = "";
      }
    }
  }

  saveAndReloadForm() {
    loader.show();
    this.saveDraft({render_form: true})
      .catch(response => response)
      .then(response => {
        if (response && response.form_html) {
          this.disconnect();
          this.form.outerHTML = response.form_html;
        }
        loader.hide();
      })
      .catch(() => loader.hide());
  }

  async saveDraft(options = {}) {
    if (!this.form) {
      return Promise.reject("Form not found.");
    }

    let url = `/offer/draft/ajax-save/machine_id/${this.element.dataset.machineId}/`;
    if (options.render_form) {
      url += "render_form/1/";
    }
    return fetchJson(url, {
      method: "post",
      body: new FormData(this.form)
    })
      .then(response => {
        if (typeof response.messages === "object" && Object.keys(response.messages).length > 0) {
          return Promise.reject(response);
        }
      });
  }

  get manufacturer_id() {
    return this.hasManufacturer_idTarget && parseInt(this.manufacturer_idTarget.value);
  }

  get form() {
    if (this._form === void 0) {
      let form = this.element;
      if (form.nodeName !== "FORM") {
        form = form.querySelector("form");
      }
      if (form) {
        this._form = form;
      }
    }
    return this._form;
  }
}
